import React from "react";
import { ToastContainer } from "react-toastify";

import SettingsProfitAndLoss from "./components/SettingsProfitAndLoss";

const SettingsProfitAndLossApp = (props) => (
  <>
    <ToastContainer icon={false} />
    <SettingsProfitAndLoss {...props} />
  </>
);

export default SettingsProfitAndLossApp;
